import {FlowMeterType, flowMeterTypes} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<FlowMeterType>;

export const FlowMeterTypeSelect = (props: Props) => {
  const {options = flowMeterTypes, ...rest} = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
